<div [formGroup]="addressForm">
  <div class="fx-layout-row fx-layout-xs-column">
    <mat-form-field>
      <mat-label>Address Line 1</mat-label>
      <input
        matInput
        formControlName="addressLine1"
        type="text"
        [required]="requiredValidator"
        />
        @if (addressForm.get('addressLine1').hasError('required')) {
          <mat-error>
            This is a required field
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Address Line 2</mat-label>
        <input
          matInput
          formControlName="addressLine2"
          type="text"
          />
        </mat-form-field>
      </div>
      <div class="fx-layout-row fx-layout-xs-column">
        <mat-form-field>
          <mat-label>Country</mat-label>
          <mat-select
            formControlName="country"
            (selectionChange)="onCountryChange($event.value)"
            [required]="requiredValidator">
            <mat-option value="-1">Select Country</mat-option>
            @for (country of countries; track country) {
              <mat-option
                [value]="country.code">
                {{ country.name }}
              </mat-option>
            }
          </mat-select>
          @if (addressForm.get('country').hasError('required')) {
            <mat-error>
              This is a required field
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field>
          <mat-label>State</mat-label>
          <mat-select
            formControlName="state"
            (selectionChange)="onStateChange($event.value)"
            [required]="requiredValidator">
            <mat-option value="-1">Select State</mat-option>
            @for (state of listOfStates; track state) {
              <mat-option
                [value]="state.abbreviation">
                {{ state.name }}
              </mat-option>
            }
          </mat-select>
          @if (addressForm.get('state').hasError('required')) {
            <mat-error>
              This is a required field
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="fx-layout-row fx-layout-xs-column">
        <mat-form-field>
          <mat-label>City</mat-label>
          <input
            matInput
            formControlName="city"
            type="text"
            [required]="requiredValidator"
            />
            @if (addressForm.get('city').hasError('required')) {
              <mat-error>
                This is a required field
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Zip Code</mat-label>
            <input
              matInput
              formControlName="postCode"
              type="text"
              [required]="requiredValidator"
              />
              @if (addressForm.get('postCode').hasError('required')) {
                <mat-error>
                  This is a required field
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
